import { api } from './_ApiFactoryWithHeader';
import { AUDIENCE, WEB_CLIENT_CREDENTIAL_TOKEN } from '../Redux/Constant/ServerConstant';

import { apiGeneral } from './_General';
let refreshingTokenPromise = null;

export const apiAuth = {
	// get client credentials
	getClientCredentials: () => api.postUrlFormEncoded('auth', {
		audience: AUDIENCE, grant_type: 'client_credentials',
	}, {
			headers: {
				'Authorization': `Basic ${WEB_CLIENT_CREDENTIAL_TOKEN}`,
				'Access-Control-Allow-Origin': '*',
			}
		}
	),

	getUserAccess: (params,token,cb,eCb)=>{
		apiGeneral.apiFetch('access_rights', params, token, cb, eCb);
	},

	// register
	register: (body, token, cb, eCb) => {
		apiGeneral.apiPost('users', body, token, cb, eCb)
	},

	// login
	authenticate: (username, password) => api.postUrlFormEncoded('auth', {
		username, password, audience: AUDIENCE, grant_type: 'password',
	}, {
			headers: {
				'Authorization': `Basic ${WEB_CLIENT_CREDENTIAL_TOKEN}`,
				'Access-Control-Allow-Origin': '*',
			}
		}
	),

	// logout
	revoke: (token) => api.postUrlFormEncoded('token/revoke', {
		token
	}, {
			headers: {
				'Authorization': `Basic ${WEB_CLIENT_CREDENTIAL_TOKEN}`,
				'Access-Control-Allow-Origin': '*',
			}
		}
	),

	// get user information
	getUserInformation: (params, token, cb, eCb) => {
		apiGeneral.apiFetch('user/me', params, token, cb, eCb);
	},
	getCurrentUserInformation: (params, cancelToken) => {
		return api.get(`user/me`, params, null, cancelToken)
	},

	// refresh token by refresh token
	refreshTokenByRefreshToken: (token, cb, eCb) => {
		apiGeneral.apiPostRefreshToken('auth', {
			headers: {
				'Authorization': `Basic ${WEB_CLIENT_CREDENTIAL_TOKEN}`,
				'Accept': 'application/json',
				'Content-Type': 'application/x-www-form-urlencoded',
			}
		}, token, cb, eCb);
	},
	refreshToken: refreshToken => {
		if (!refreshingTokenPromise) {
			refreshingTokenPromise = api.postUrlFormEncoded('auth', {
				grant_type: 'refresh_token',
				refresh_token: refreshToken
			}, {
				headers: {
					'Authorization': `Basic ${WEB_CLIENT_CREDENTIAL_TOKEN}`
				}
			}).then(result => {
				refreshingTokenPromise = null;
				return result;
			}, error => {
				refreshingTokenPromise = null;
				throw error;
			});
		}
		return refreshingTokenPromise;
	},

	// forget password
	forgetPassword: (value, params, token, cb, eCb, accept, contentType) => {
		apiGeneral.apiFetchCustom(`users/${value}/forget_password`, params, token, cb, eCb, accept, contentType)
	},

	// reset password
	resetPassword: (value, body, token, cb, eCb) => {
		apiGeneral.apiPut(`users/${value}/reset_password`, body, token, cb, eCb)
	}
};
